import {bindable, customElement} from 'aurelia-framework';

@customElement('sio-geometry')
export class GeometryInput {
    @bindable field;
    @bindable value; // expected to be an array of routes: [{ geometry: string, stops: [{ lat, lng, name }] }]
    @bindable config;

    iframe;

    attached() {
        // Validate input data
        if (!Array.isArray(this.value) || this.value.length === 0) {
            console.warn('No valid route data');
            return;
        }

        // Generate HTML content and load it into the iframe
        const html = this.getHtmlForRoutes(this.value);
        const blob = new Blob([html], { type: 'text/html' });
        this.iframe.src = URL.createObjectURL(blob);
    }

    getHtmlForRoutes(routes) {
        return `
            <!DOCTYPE html>
            <html lang="de">
                <head>
                    <meta charset="utf-8">
                    <title>Routes</title>
                    <link rel="stylesheet" href="https://unpkg.com/leaflet/dist/leaflet.css" />
                    <style>
                    html, body { margin: 0; padding: 0; height: 100%; }
                    #map { width: 100%; height: 90%; }
                    #controls { height: 10%; padding: 10px; background: #f4f4f4; }
                    label { margin-right: 20px; font-size: 14px; }
                    .stop-label {
                      background: white;
                      border: 1px solid #ccc;
                      padding: 2px 5px;
                      border-radius: 4px;
                      font-size: 12px;
                      color: #333;
                    }
                    </style>
                </head>
                <body>
                    <div id="controls"></div>
                    <div id="map"></div>
                    
                    <script src="https://unpkg.com/leaflet/dist/leaflet.js"></script>
                    <script src="https://unpkg.com/@mapbox/polyline"></script>
                    <script>
                        const routes = ${JSON.stringify(routes)};
                        const map = L.map('map').setView([50.934, 6.93], 13);
                        
                        // Load OpenStreetMap base layer
                        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                          attribution: '© OpenStreetMap contributors'
                        }).addTo(map);
                        
                        // Define colors to distinguish routes
                        const colors = ['blue', 'green', 'orange', 'purple', 'red'];
                        const polylines = [];
                        const markerGroups = [];
                        const tooltipGroups = [];
                        
                        // Create polyline and markers for each route
                        routes.forEach((route, routeIndex) => {
                            const latlngs = polyline.decode(route.geometry);
                            const color = colors[routeIndex % colors.length];
                            const line = L.polyline(latlngs, { color, weight: 4 });
                            
                            const markers = [];
                            const tooltips = [];
                            
                            route.stops.forEach((stop, index) => {
                            const isFirst = index === 0;
                            const isLast = index === route.stops.length - 1;
                            const pointColor = isFirst ? 'green' : isLast ? 'red' : 'black';
                            
                            // Draw circle marker for each stop
                            const marker = L.circleMarker([stop.lat, stop.lng], {
                              radius: 6,
                              fillColor: pointColor,
                              color: '#000',
                              weight: 1,
                              opacity: 1,
                              fillOpacity: 0.9
                            });
                            
                            // Add permanent label for the stop
                            const tooltip = L.tooltip({
                              permanent: true,
                              direction: 'top',
                              offset: [0, -8],
                              className: 'stop-label'
                            })
                            .setContent(stop.name)
                            .setLatLng([stop.lat, stop.lng]);
                            
                            markers.push(marker);
                            tooltips.push(tooltip);
                          });
                        
                          polylines.push(line);
                          markerGroups.push(markers);
                          tooltipGroups.push(tooltips);
                        });
                        
                        // Create checkbox controls to toggle routes
                        const controls = document.getElementById('controls');
                        
                        routes.forEach((route, index) => {
                            const label = document.createElement('label');
                            label.innerHTML = \`<input type="checkbox" data-index="\${index}" checked> Route \${index + 1}\`;
                            controls.appendChild(label);
                            
                            // Enable all routes by default
                            polylines[index].addTo(map);
                            markerGroups[index].forEach(m => m.addTo(map));
                            tooltipGroups[index].forEach(t => map.addLayer(t));
                        });
                        
                        // Fit the map to show all active routes
                        map.fitBounds(L.featureGroup(polylines).getBounds());
                        
                        // Toggle route visibility based on checkbox state
                        controls.addEventListener('change', e => {
                            const idx = parseInt(e.target.dataset.index);
                            const line = polylines[idx];
                            const markers = markerGroups[idx];
                            const tooltips = tooltipGroups[idx];
                            
                            if (e.target.checked) {
                                line.addTo(map);
                                markers.forEach(m => m.addTo(map));
                                tooltips.forEach(t => map.addLayer(t));
                                map.fitBounds(line.getBounds());
                            } else {
                                map.removeLayer(line);
                                markers.forEach(m => map.removeLayer(m));
                                tooltips.forEach(t => map.removeLayer(t));
                            }
                        });
                    </script>
                </body>
            </html>`.trim();
    }
}
